export default __webpack_public_path__ + "static/media/A Father's Will.76f90760.jpg";